import React, { useEffect } from 'react';
import { Translate } from 'react-localize-redux';
import css from './page.css';
import { Button, Spinner } from '../components/widgets';
import ReferralsIcon from '../resources/svg/referrals_icon.svg';
import AgencyEmptyState from '../components/partials/AgencyEmptyState';
import PartnerEmptyState from '../components/partials/PartnerEmptyState';

function PartnersLandingPage({
    partnerName = '',
    openDialog = () => {},
    onFetchOrganizations = () => {},
    accountTypeReady = false,
    isAgency = false,
    agencyName = '',
    agencyId = '',
    organizations = [],
    loading = false,
}) {
    useEffect(() => {
        if (accountTypeReady) {
            onFetchOrganizations();
        }
    }, [accountTypeReady]);

    const showSpinner = !accountTypeReady || loading;
    const showAgencyEmptyState = accountTypeReady && isAgency && !loading && organizations.length === 0;
    const showPartnerEmptyState = accountTypeReady && !isAgency && !loading && organizations.length === 0;

    return (
        <div className={css.container}>
            <div className={css.header}>
                <Translate id="STATIC.PAGES.PARTNERS_PORTAL.LANDING_PAGE_HEADER" data={{ partnerName }} />
            </div>
            {showSpinner ? (
                <Spinner show />
            ) : showAgencyEmptyState ? (
                <AgencyEmptyState agencyName={agencyName} agencyId={agencyId} />
            ) : showPartnerEmptyState ? (
                <PartnerEmptyState />
            ) : (
                <>
                    <div className={css.subHeader}>
                        <Translate id="STATIC.PAGES.PARTNERS_PORTAL.LANDING_PAGE_SUB_HEADER" />
                    </div>
                    <ReferralsIcon />
                    <Button className={css.button} level="important" onClick={openDialog}>
                        <Translate id="STATIC.PAGES.PARTNERS_PORTAL.LANDING_PAGE_BUTTON" />
                    </Button>
                </>
            )}
        </div>
    );
}

export default PartnersLandingPage;
